import PolicyTypeBadge from "components/PolicyTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PolicyTemplate } from "types/generated";

const PoliciesTemplatesTableTypesCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PolicyTemplate>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <PolicyTypeBadge type={template.type} />
    </TableSimpleCell>
  );
};

export default PoliciesTemplatesTableTypesCell;
